import red from '@material-ui/core/colors/red';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#556cd6',
        },
        secondary: {
            main: '#19857b',
        },
        error: {
            main: red.A400,
        },
        background: {
            default: '#fff',
        },
    },
});

export default theme;

export const trafficLight = {
    bred : "#f21a31",
    byellow : "#ffda66",
    bgreen : "#8ace7e",
    vgreen : "#309143",
    bgrey : "#C4C4C4",

    red : "#680400",
    yellow : "#986022",
    green : "#306821",
    dgrey : "#535353",
    grey: "#888c88",

    // for the control measure heat maps
    cmred: "#f21a31",
    cmorange: "#ff9900",
    cmdorange: "#e39802",
    cmyellow: "#ffda66",
    cmgreen: "#309143",
    cmgrey: "#888c88",

}